import { ContactVM } from 'src/models/faculty.model';
import { baseApi } from './baseApi.service';
import { ENDPOINT } from '../config/apiTags';
import { ContactIM } from '@tto/shared-models';

const contactApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllContacts: builder.query<ContactVM[], void>({
      query: () => ({
        url: `${ENDPOINT.CONTACT}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
              // Tag the whole list
              { type: 'Contact', id: 'LIST' },
              // Tag each contact individually
              ...result.map(({ id }) => ({ type: 'Contact' as const, id })),
            ]
          : [{ type: 'Contact', id: 'LIST' }],
    }),
    createUnassignedContact: builder.mutation<ContactVM, ContactIM>({
      query: (contact) => ({
        url: `${ENDPOINT.CONTACT}`,
        method: 'POST',
        body: contact,
      }),
      invalidatesTags: (result) => (result ? [{ type: 'Contact', id: 'LIST' }] : []),
    }),
    updateContacts: builder.mutation<string, { id: string; name: string; email: string }>({
      query: ({ id, name, email }) => ({
        url: `${ENDPOINT.CONTACT}/${id}`,
        method: 'PATCH',
        body: { name, email },
      }),
    }),
    getUnassignedContacts: builder.query<ContactVM[], void>({
      query: () => ({
        url: `${ENDPOINT.CONTACT}/unassigned`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
              // Tag the whole list
              { type: 'Contact', id: 'LIST' },
              // Tag each contact individually
              ...result.map(({ id }) => ({ type: 'Contact' as const, id })),
            ]
          : [{ type: 'Contact', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetAllContactsQuery,
  useUpdateContactsMutation,
  useGetUnassignedContactsQuery,
  useCreateUnassignedContactMutation,
} = contactApi;
